module.exports = __webpack_public_path__ + "img/cozu.f82afe89.jpeg";